import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { debounce } from 'lodash';
import { loadHorses, resetHorses } from '../reducers/myStableHorseSearch';
import { loadJockeys, resetJockeys } from '../reducers/myStableJockeySearch';
import { loadTrainers, resetTrainers } from '../reducers/myStableTrainerSearch';

import SearchIcon from 'modules/Common/components/svg/SearchIcon';

require('./MyStableSearch.scss');

export default class MyStableSearch extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func.isRequired
    }).isRequired
  }

  constructor(props) {
    super(props);
    this.state = {text: ''};
    this.debouncedSearch = debounce(this.debouncedSearch, 300);
  }

  componentWillUnmount() {
    this.resetSearchResults();
  }

  resetSearchResults() {
    // don't care about preserving order
    this.props.dispatch(resetHorses());
    this.props.dispatch(resetJockeys());
    this.props.dispatch(resetTrainers());
  }

  search(inputText) {
    // "Clean" the input
    const searchText = inputText.replace(/[\|&;\$%@"'<>\(\)\+,]/g, "").trim();

    if (searchText.length > 0) {
      this.props.dispatch(loadHorses(searchText));
      this.props.dispatch(loadJockeys(searchText));
      this.props.dispatch(loadTrainers(searchText));
    } else {
      this.resetSearchResults();
    }
    this.props.router.push('/racing/my-stable/search');
  }

  debouncedSearch(searchText) {
    this.search(searchText);
  }

  handleChange({target: { value: searchText}}) {
    this.setState({text: searchText}, () => {
      this.debouncedSearch(searchText);
    });
  }

  handleKeyDown({keyCode}) {
    if (keyCode === 13) {
      this.search(this.state.text);
    }
  }

  render() {
    return (
      <div className="my-stable-search-box">
        <input type="text" value={this.state.text} maxLength={20} onKeyDown={ e => this.handleKeyDown(e) } onChange={ e => this.handleChange(e) }/>
        <button id="my-stable-search-btn" className="search-icon-btn" onClick={() => this.search(this.state.text)}><SearchIcon/></button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/MyStableSearch.js